import React, { useState, useEffect } from 'react';
import Navbar from 'components/Navbars/AuthNavbar'
import Footer from 'components/Footers/Footer'
import Swal from 'sweetalert2';
import BASE_URL from 'components/BaseUrl/apiConfig';
import BlockUiOverlay from 'components/Expense/BlockUiOverlay';

const Settings = () => {

    const [email, setEmail] = useState('');
    const [ccEmail, setCCEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [currency, setCurrency] = useState("");
    const [loading, setLoading] = useState(true);




    //get userid form loca storage
    const storedUserData = localStorage.getItem('userData');
    let userId = '';
    let userTypeId = '';
    let groupId = '';

    if (storedUserData) {
        const userData = JSON.parse(storedUserData);
        userId = userData.userId;
        userTypeId = userData.userTypeId;
        groupId = userData.groupId;
    }


    useEffect(() => {
        // Fetch email address from the API
        const fetchEmail = async () => {
            try {
                const storedUserData = localStorage.getItem('userData');
                if (storedUserData) {
                    const userData = JSON.parse(storedUserData);
                    const userId = userData.userId;

                    const response = await fetch(`${BASE_URL}/api/Settings/GetEmailforExpenseReport?userid=${userId}`);
                    const data = await response.json();
                    // Assuming the API response has an 'email' field, update the state
                    setEmail(data.email);
                    setCCEmail(data.ccEmail)
                }
            } catch (error) {
                console.error('Error fetching email:', error);
            }
        };

        fetchEmail();
    }, [userId]);


    useEffect(() => {
        const fetchCurrencyData = async () => {
            try {
                setLoading(true)
                const response = await fetch(`${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`);
                const data = await response.json();
                // Assuming the API response has a property called 'currency'
                setCurrency(data.currency);

            } catch (error) {
                console.error("Error fetching currency data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCurrencyData();
    }, []); // The empty dependency array ensures that this effect runs only once when the component mounts



    const handleUpdate = async () => {

        // Check if the selected currency is empty or null
        if (!currency) {
            // Display SweetAlert validation message
            Swal.fire({
                title: 'Something went wrong.',
                text: 'Please choose a currency',
                icon: 'error',
            });
            return; // Do not proceed with the update
        }

        // Display SweetAlert confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to update the currency?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
        });
        // If the user clicks on "Yes"
        if (result.isConfirmed) {
            try {
                const response = await fetch(`${BASE_URL}/api/Users/UpdateCurrencybyUserId?userid=${userId}&Currency=${currency}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                // Check if the update was successful (status code 200)
                if (response.ok) {
                    // Display SweetAlert success message with the API response
                    Swal.fire({
                        title: 'Success',
                        text: `Currency updated successfully.`,
                        icon: 'success',
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: `Failed to update currency. API Error Response:`,
                        icon: 'error',
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: 'Error',
                    text: `Error updating currency: ${error.message}`,
                    icon: 'error',
                });
            }
        }
    };


    //here is the code of the button click
    // ... (existing code)

    const handleButtonClick = async () => {
        try {
            // Validation: Check if the email is valid
            // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const trimmedEmail = email.replace(/\s/g, ""); // Remove leading and trailing spaces from email
            const emailRegex = /^([^\s@]+@[^\s@]+\.[^\s@]+)(,[^\s@]+@[^\s@]+\.[^\s@]+)*$/;
            const trimmedccEmail = ccEmail.replace(/\s/g, "");
            if (!emailRegex.test(trimmedEmail)) {
                throw new Error('Please enter a valid email address.');
            }

            const actionText = email ? 'update' : 'insert';
            const result = await Swal.fire({
                title: 'Confirmation!',
                text: `Are you sure you want to ${actionText} this email?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: actionText.charAt(0).toUpperCase() + actionText.slice(1), // Capitalize the action text
            });

            if (result.isConfirmed) {
                const apiUrl = `${BASE_URL}/api/Settings/AddEmailforExpenseReport?email=${email}&userid=${userId}&ccEmail=${ccEmail}`;
                const response = await fetch(apiUrl, { method: 'POST' });

                if (response.ok) {
                    const actionPastTense = email ? 'updated' : 'inserted';
                    await Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: `Email ${actionPastTense} successfully!`,
                        showConfirmButton: true,
                        onClose: () => {
                            // Additional logic after the alert is closed
                        },
                    });
                } else {
                    throw new Error('Error updating/inserting email');
                }
            }
        } catch (error) {
            console.error('Error updating/inserting email:', error);
            Swal.fire({
                icon: 'error',
                title: 'Something went wrong.',
                text: error.message,
            });
        }
    };

    // ... (existing code)



    const buttonText = email ? 'Update' : 'Save';

    return (
        <>
            <Navbar />
            <div className='cust-div'>
                <BlockUiOverlay visible={loading} />
                <div className="container mx-auto mt-8 p-4">
                    <h1 className="text-2xl uppercase font-bold">Settings</h1>
                </div>
                <div className="container mx-auto  flex flex-col items-center">
                    <form >

                        <div className="flex items-center mb-2"> {/* Flex container for label and input pair */}
                            <label htmlFor="expenseTypeEmail" className="block text-sm mr-2 uppercase font-medium text-gray-700">
                                Send Expenses Report to
                            </label>
                            {
                                userTypeId != 3 ? (<input
                                    type="text"
                                    id="expenseTypeEmail"
                                    name="expenseTypeEmail"
                                    className='rounded'
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />) : (
                                    <input
                                        type="text"
                                        id="expenseTypeEmail"
                                        name="expenseTypeEmail"
                                        className='rounded'
                                        value={email}
                                        disabled
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                )
                            }
                        </div>

                        <div className="flex justify-center">
                            <div className="flex items-center mb-2"> {/* Flex container for label and input pair */}
                                <label htmlFor="ccEmail" className="block text-sm  uppercase font-medium text-gray-700">
                                    CC Email Address
                                </label>
                                {
                                    userTypeId != 3 ? (<input
                                        type="text"
                                        id="ccEmail"
                                        name="ccEmail"
                                        className='rounded'
                                        value={ccEmail}
                                        style={{ marginLeft: '62px' }}
                                        onChange={(e) => setCCEmail(e.target.value)}
                                    />) : (
                                        <input
                                            type="text"
                                            id="ccEmail"
                                            name="ccEmail"
                                            className='rounded'
                                            value={ccEmail}
                                            style={{ marginLeft: '62px' }}
                                            disabled
                                            onChange={(e) => setCCEmail(e.target.value)}
                                        />
                                    )
                                }
                            </div>
                        </div>
                        {userTypeId !== 3 && (
                            <div className="flex justify-end w-full p-1"> {/* Flex container to align button to the end */}
                                <button
                                    type="button"
                                    className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                                    onClick={handleButtonClick}
                                >
                                    {buttonText}
                                </button>
                            </div>
                        )}
                    </form>
                </div>







                <hr className="mb-4  mx-auto px-4 border-b-1 border-blueGray-200" />

                {/* here is the code of choose currensy */}




                <div className="container mx-auto  p-4">
                    <h1 className="text-2xl uppercase font-bold">Choose Currency</h1>
                </div>
                <div className="container mx-auto p-4 flex flex-col items-center">
                    {loading ? (
                        <p>Loading...</p>
                    ) : (
                        <form className="flex  p-5  items-center">
                            <label htmlFor="expenseTypeName" className="block text-sm mr-3 flex uppercase font-medium text-gray-700">
                                Choose Currency
                            </label>


                            {
                                userTypeId != 3 ? (<select id="currency" name="currency" className='rounded' value={currency} onChange={(e) => setCurrency(e.target.value)} >
                                    <option value="">Choose Currency</option>
                                    <option value="INR">INR</option>
                                    <option value="USD">US dollar</option>
                                    <option value="Dinar">Dinar</option>
                                    <option value="Euro">Euro</option>
                                </select>) : (<select id="currency" name="currency" className='rounded' value={currency} onChange={(e) => setCurrency(e.target.value)} disabled >
                                    <option value="">Choose Currency</option>
                                    <option value="INR">INR</option>
                                    <option value="USD">US dollar</option>
                                    <option value="Dinar">Dinar</option>
                                    <option value="Euro">Euro</option>
                                </select>)
                            }


                            {
                                userTypeId != 3 ? (<button
                                    type="button"
                                    onClick={handleUpdate}
                                    className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 ml-2"
                                >
                                    Update
                                </button>) : (
                                    null
                                )
                            }
                        </form>
                    )}
                </div>

            </div >
            <Footer />
        </>
    )
}

export default Settings
